/**
 * Generated runtime TestId mirror for frontend/src/components/entity-type/color-picker.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const ColorPickerTestIds = {
  btnColorPicker: "btn-color-picker",
  colorOption: (color: string) => `color-option-${color}`,
  colorOptionPrefix: () => "color-option-" as TestIdPrefix
} as const;
